<script>
export default {
  name: 'OrderBy',
  inheritAttrs: false,
  functional: true,
  props: {
    func: {
      type: Function,
      required: true
    }
  },
  render (createElement, context) {
    context.children.sort(context.props.func)
    return context.children
  }
}
</script>
